import Modal from '../common/Modal';
import PropertyForm from './PropertyForm';
import { Box, Grid } from '@mui/material';
import React, { useState } from 'react';
import { Property } from 'vendor-marketplace-shared-library';
import { PropertyFormInput } from '../../types/property';

type PropertyFormModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSubmit: (formData: PropertyFormInput) => void;
  property?: Property;
};

export default function PropertyFormModal(props: PropertyFormModalProps) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<PropertyFormInput>({
    name: props.property?.name || '',
    address1: props.property?.address1 || '',
    address2: props.property?.address2 || '',
    city: props.property?.city || '',
    state: props.property?.state || '',
    zipcode: props.property?.zipcode || '',
  });

  const onCreate = async () => {
    setLoading(true);
    props.onSubmit({
      name: formData.name || null,
      address1: formData.address1 || null,
      address2: formData.address2 || null,
      city: formData.city || null,
      state: formData.state || null,
      zipcode: formData.zipcode || null,
    });
    setLoading(false);
  };

  return (
    <Modal
      open={props.open}
      setOpen={props.setOpen}
      title={props.property ? 'Update Property' : 'Create Property'}
    >
      <Grid container item xs={12} padding={2} sx={{ width: { xs: '300px', sm: '500px' } }}>
        <PropertyForm
          onSubmit={onCreate}
          loading={loading}
          formData={formData}
          setFormData={setFormData}
          submitButtonText={props.property ? 'Update Property' : 'Add Property'}
        />
      </Grid>
    </Modal>
  );
}
